import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';

import { MfaSetupForm } from '../features';
import { WindowContext } from '../shared/components';
import { urls } from '../shared/utils';

/** Integrates MfaSetupForm with other pages and screens */
function MfaSetupPage(): JSX.Element {
  const location = useLocation();
  const url = new URLSearchParams(location.search).get('url');
  const { locationAssign } = useContext(WindowContext);

  const handleCancel = () => {
    locationAssign(urls.Logout);
  };

  const handleSuccess = () => {
    locationAssign(url ?? urls.LoginInit);
  };

  return <MfaSetupForm onCancel={handleCancel} onSuccess={handleSuccess} />;
}

export const Component = MfaSetupPage;
export const title = 'MFA Setup';
export const path = urls[title];
